import '../../core/components/app-root/AppRoot.css';
import './CodeHighlight.css';
import './CodeSnippet.css';
import { createRuntimeFn as _7a468 } from '@vanilla-extract/recipes/createRuntimeFn';
export var copyButtonContainer = _7a468({defaultClassName:'_17pa72a6-3-8-0',variantClassNames:{size:{'default':'_17pa72a7-3-8-0',condensed:'_17pa72a8-3-8-0'}},defaultVariants:{size:'default'},compoundVariants:[]});
export var wrapper = '_17pa72a1-3-8-0';
export var wrapperFullHeight = '_17pa72a2-3-8-0';
export var wrapperGutter = _7a468({defaultClassName:'_17pa72a3-3-8-0',variantClassNames:{size:{'default':'_17pa72a4-3-8-0',condensed:'_17pa72a5-3-8-0'}},defaultVariants:{size:'default'},compoundVariants:[]});